import { createRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ProjectsBrowser } from '@/features/projects/projects-browser';
import {
  validateProjectsSearch,
  type ProjectsSearch,
} from '@/features/projects/projects-search';

import { rootRoute } from './root.route';

/**
 * Home — the project list (spec R6.5).
 *
 * The route owns the URL and nothing else. `validateSearch` is what makes the
 * address bar the source of truth for search, sort and page: it parses on the
 * way in, so a reload or a link pasted from a colleague restores the same view,
 * and it normalises on the way out, so a default value never appears in the URL.
 */
const HomePage = () => {
  const search = homeRoute.useSearch();
  const navigate = homeRoute.useNavigate();

  const handleSearchChange = useCallback(
    (next: ProjectsSearch, replace = false) => {
      void navigate({ to: '/', search: () => next, replace });
    },
    [navigate],
  );

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Projects
        </h1>
        <p className="text-sm text-muted-foreground">
          Every prototype under review, grouped by the project it belongs to.
        </p>
      </div>

      <ProjectsBrowser search={search} onSearchChange={handleSearchChange} />
    </div>
  );
};

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  validateSearch: validateProjectsSearch,
  component: HomePage,
});
